import request from "@/utils/request";
import service from "@/utils/axios-v2";
// onboarding状态接口
export function getOnboardingStatus(parameter) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/company/onboarding_status`,
    method: "get",
    isNotPrompt: true,
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// 修改onboarding页展示状态
export function changeOnboardingShow(onboardingShow) {
  return request({
    url: `/fleet/company/onboarding_show?onboardingShow=${onboardingShow}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// SelectPopup
export function SelectPopup(params) {
  let url = "https://smallcall-api.truckerpath.com/tic/v1.0/web-form";
  if (
    process.env.NODE_ENV !== "production" ||
    process.env.VUE_APP_RUNTIME_ENV === "qa"
  ) {
    url += "?test=true";
  }
  const data = {
    formId: "3739",
    webFormFieldVos: [
      {
        fieldId: "22463",
        formId: "3739",
        fieldPath: "companyPhone",
        fieldValue: params.phone,
      },
      // {
      //   fieldId: "22450",
      //   formId: "3739",
      //   fieldPath: "jobTitle",
      //   fieldValue: params.formDataJobTitle,
      // },
      {
        fieldId: "22460",
        formId: "3739",
        fieldPath: "firstName",
        fieldValue: params.formDataFirstName,
      },
      {
        fieldId: "22461",
        formId: "3739",
        fieldPath: "lastName",
        fieldValue: params.lastName,
      },
      {
        fieldId: "22462",
        formId: "3739",
        fieldPath: "companyEmail",
        fieldValue: params.email,
      },
      {
        fieldId: "22464",
        formId: "3739",
        fieldPath: "employeesNumber",
        fieldValue: params.employeesNumber,
      },
    ],
    defaultFieldVos: [],
  };
  return request({
    url: url,
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  });
}
// setWelcomeSetp
export function setWelcomeSetp(data) {
  let url = data.step
    ? `/fleet/user/welcome/step/set?step=${data.step}`
    : `/fleet/user/welcome/step/set`;
  return request({
    url: url,
    method: "put",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
export function openTLLoadDetailShow(params) {
  return request({
    url: '/fleet/user/extend/update/behavior',
    method: "get",
    params,
    headers: {
      "portal-token": true,
    }
  })
}

export function onboardingCompleteStatus(data) {
  return request({
    url: '/fleet/company/onboarding_complete',
    method: "post",
    data,
    headers: {
      "portal-token": true,
    }
  })
}
export function updateGuide(params) {
  return request({
    url: '/fleet/user/extend/update/common/guide',
    method: "get",
    params,
    headers: {
      "portal-token": true,
    }
  })
}
